import { FullDialogButton, TooltipSheetButton } from "@/components/format/Buttons";
import { CircleHelp, Pencil } from "lucide-react";
import CodeHike from "@/components/codehike/CodeHike";
import { Header } from "@/components/format/Dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useCourse, useUser } from "@/lib/store";
import { ROLES } from "@/lib/roles";
import { CourseEditForm } from "../course/CourseAdminForms";
import { Button } from "@/components/ui/button";
import { useState } from "react";

export function CheatsheetButton({
  className,
  showInfo,
}: {
  className?: string;
  showInfo?: boolean;
}) {
  const course = useCourse();
  const user = useUser();

  const isAdmin = user?.role == ROLES.administrator;

  const [sheet, setSheet] = useState(course?.cheatsheet)

  function expand(on = true) {
    if (!course?.cheatsheet) return;

    const openState = on ? 'true' : 'false';
    const oppositeState = on ? 'false' : 'true';
    const updated = course.cheatsheet.replace(
      new RegExp(`defaultOpen=\\{${oppositeState}\\}`, 'g'),
      `defaultOpen={${openState}}`
    );

    setSheet(updated);
  }


  if (!course.cheatsheet && !isAdmin) return;
  return (
    <TooltipSheetButton
      icon={CircleHelp}
      info="Cheatsheet"
      variant="ghost"
      size="sm"
      className={className}
      showInfo={showInfo}
    >
      <div className="flex flex-col w-full h-screen gap-2 border border-success">
        <Header
          title={<HeaderCheatsheet isAdmin={isAdmin} expand={expand}/>}
          description={""}
        />
        <ScrollArea className="">
          <div className="h-[87dvh] flex flex-col w-full gap-6">
            <Cheatsheet cheatsheet={sheet}/>
          </div>
        </ScrollArea>
      </div>
    </TooltipSheetButton>
  );
}

function HeaderCheatsheet({ isAdmin, expand }: { isAdmin: boolean; expand: () => void }) {
  const course = useCourse();
  
  return (
    <div className="flex gap-2 items-center text-success p-2 border border-success">
      <CircleHelp /> Course Cheatsheet
      {isAdmin && (
        <div className="text-foreground">
          <FullDialogButton
            icon={Pencil}
            item={course.original || course}
            contents={CourseEditForm}
            variant="outline"
            className="h-6 px-2 w-6 "
          />
          
        </div>
      )}
      <div className="ms-4">
        <Button variant="outline" className="h-6 px-4 text-foreground " onClick={expand}>
          Expand all
        </Button>
        <Button variant="outline" className="h-6 px-4 text-foreground " onClick={()=>expand(false)}>
          Collapse all
        </Button>
      </div>
    </div>
  );
}

export function Cheatsheet({cheatsheet} : {cheatsheet:string}) {
 

  if (!cheatsheet) return null;
  return <CodeHike code={cheatsheet} />;
}
